import { ReactElement } from 'react';
import { PageProps } from '../../index';
import InfoPanel from '../../infoPanel';
import Person from '../../person';
import DetailsPanelMobile from '../../detailsPanel/mobile';
import { StyledMobilePage } from './styles';

const PageMobile = ({
  data,
  handleOpenModalPersonal,
  handleOpenModalOrder,
  handleTestPerformed,
  handleOrderConfirmed,
  handleAddResultsOpen,
  handleDeleteOrderOpen,
  handlePreviousStageOrderOpen,
  handleResendCertificate,
  handleGenerateCertificate,
  showPreviousStageAndGenerateCertificateButtons,
  isOrderStatusDone,
}: PageProps): ReactElement => {
  return (
    <StyledMobilePage>
      <InfoPanel data={data} />
      <Person
        data={data}
        handleAddResultsOpen={handleAddResultsOpen}
        handleOrderConfirmed={handleOrderConfirmed}
        handleTestPerformed={handleTestPerformed}
        handleDeleteOrderOpen={handleDeleteOrderOpen}
        handlePreviousStageOrderOpen={handlePreviousStageOrderOpen}
        handleResendCertificate={handleResendCertificate}
        handleGenerateCertificate={handleGenerateCertificate}
        showPreviousStageAndGenerateCertificateButtons={
          showPreviousStageAndGenerateCertificateButtons
        }
      />
      <DetailsPanelMobile
        data={data}
        handleOpenEditPersonal={handleOpenModalPersonal}
        handleOpenEditOrder={handleOpenModalOrder}
        isOrderStatusDone={isOrderStatusDone}
      />
    </StyledMobilePage>
  );
};

export default PageMobile;
